<template>
  <div>
    <div class="cardCustom">
      <div class="card cardCustom__side">
        <div class="cardCustom__header">
          <div class="cardCustom__header-text">
            <span class="uppercase"> Import new Data </span>
          </div>
          <div class="cardCustom__header-info__item">
            <button
              v-tooltip="{
                content: 'Here you can upload your PDF bills. And also you can always import new data manually.',
                placement: 'bottom-center',
                classes: ['info'],
              }"
            >
              <i class="fas fa-info-circle" />
            </button>
          </div>
        </div>
        <div class="content pt-20">
          <!--          Todo: Do not delete this lines-->
          <div class="pb-10" v-if="isElectricityConsumption(consumption_category_id)">
            <h3 class="text-center pb-3">Automatic data import</h3>
            <AutomaticDataUpload></AutomaticDataUpload>
          </div>
          <div>
            <h5 class="text-center">&nbsp;</h5>
            <h3 class="text-center">Upload your invoices</h3>
            <div v-if="isElectricityConsumption(consumption_category_id)">
              <h5>
                <span class="text-danger">Important:</span> Make sure that your energy supplier
                <a href="#" @click="openConsumptionForm">is supported </a>by our system before you upload your invoices.
                If you do not find your supplier contact us so that we can add it to the system.
              </h5>
            </div>
            <div v-else-if="invoice_count >= 5">
              <h5>More than 5 invoices have been uploaded, analyisis will be available soon.</h5>
            </div>
            <div v-else>
              <h5>
                {{ invoice_count }} of 5 invoices have been uploaded. When the minimimum number have been uploaded we
                can proceed with analysis.
              </h5>
            </div>
          </div>
          <div class="h-50">
            <div class="example-avatar">
              <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                <h3>Drop files to upload</h3>
              </div>
              <div class="avatar-upload">
                <div class="text-center p-2">
                  <label>
                    <div v-if="!fileAttached">
                      <i class="upload_icon fas fa-cloud-upload-alt"></i>
                      <span class="pt-10 upload_text">Drop files anywhere to upload. </span>
                    </div>
                  </label>
                </div>
                <file-upload
                  extensions="gif,jpg,jpeg,png,webp,pdf,csv,docx,doc,xlsx"
                  accept="image/*"
                  :size="this.allowed_size"
                  :multiple="true"
                  name="avatar"
                  :thread="5"
                  :custom-action="
                    isElectricityConsumption(consumption_category_id) || isWaterConsumption(consumption_category_id)
                      ? uploadFile
                      : null
                  "
                  :drop="true"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input="inputFile"
                  ref="upload"
                >
                </file-upload>
              </div>

              <div v-if="fileAttached">
                <div v-if="isElectricityConsumption(consumption_category_id)">
                  <paper-table
                    :data="files"
                    :columns="tableColumns"
                    type="hover"
                    @clicked="openFileForm($event)"
                    class="-mt-20 mb-5"
                  >
                  </paper-table>
                  <div v-if="loadingUpload" class="text-center mb-5">
                    File analysis can take up to 2 minutes for each file. Please wait.
                  </div>
                  <div class="text-center">
                    <p-button type="danger" @click.native.prevent="remove(files)"> Remove All </p-button>
                    <p-button
                      v-if="allFilesUploadedAndAnalysed()"
                      :disabled="!allDataPassedCheck()"
                      type="success"
                      :loading="loadingSave"
                      @click.native.prevent="saveMultiData(false)"
                    >
                      Save
                    </p-button>
                    <p-button
                      v-else
                      type="success"
                      :loading="loadingUpload"
                      @click.native.prevent="$refs.upload.active = true"
                    >
                      {{ textWhileUpload }}
                    </p-button>
                  </div>
                </div>
                <div v-else>
                  <paper-table :data="files" :columns="singleColumn" type="hover" class="-mt-20 mb-5"> </paper-table>
                  <div class="text-center">
                    <p-button type="danger" @click.native.prevent="remove(files)"> Remove All </p-button>
                    <p-button type="success" :loading="loadingSave" @click.native.prevent="saveMultiData(true)">
                      Upload
                    </p-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isElectricityConsumption(consumption_category_id)">
              <div v-if="!fileAttached" class="row">
                <div class="col-md-12">
                  <h5 class="text-center mt-3">Or</h5>
                </div>
                <div class="col-md-12 text-center">
                  <p-button type="warning" @click.native.prevent="openConsumptionForm"> Upload manually </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalTemplate
      component-name="ConsumptionFileUploadFormModal"
      :data="{
        header: 'Consumption Form',
        form: selectedForm,
        file: selectedFile,
      }"
      :clicked="consumptionModal"
      @update:field="consumptionModal = false"
      @submit="updateForm($event)"
      @deleted="removeFile($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import ConsumptionController from '@/controllers/Consumption/ConsumptionController';
import ConsumptionFileController from '@/controllers/Consumption/ConsumptionFileController';
import ExtractTextController from '@/controllers/Consumption/ExtractTextController';
import ModalTemplate from '@/components/modals/ModalTemplate';
import PaperTable from '@/components/PaperTable';
import AutomaticDataUpload from '@/components/consumption/AutomaticDataUpload';

export default {
  name: 'UploadConsumptionDataCard',
  components: { AutomaticDataUpload, PaperTable, ModalTemplate },
  props: {
    consumption_category_id: Number,
    consumption_category: Object,
    invoice_count: Number,
  },
  data() {
    return {
      loadingSave: false,
      loadingUpload: false,
      fileAttached: false,
      files: [],
      edit: false,
      cropper: false,
      extractedInfo: {},
      form: {
        currency: '$',
        consumption_category_id: this.consumption_category_id,
      },
      textWhileUpload: 'Upload Files',
      tableColumns: ['Name', 'Supplier', 'Meters', 'Pages', 'Usage', 'Costs', 'Status'],
      singleColumn: ['Name'],
      consumption_categories: [],
      consumptionModal: false,
      selectedForm: {
        consumption_category_id: this.consumption_category_id,
        meters: [
          {
            meter_number: null,
            end_date: null,
            total_usage: null,
            amount_paid: null,
            account_number: null,
            days: null,
          },
        ],
      },
      selectedFile: null,
      requiredConsumptionKeys: ['total_usage', 'amount_paid', 'end_date', 'account_number', 'meter_number', 'days'],
      allowed_size: 5048576,
    };
  },
  methods: {
    inputFile(newFiles) {
      this.fileAttached = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(pdf)$/i.test(newFile.name)) {
          this.alert('Format of your file is invalid');
          return prevent();
        }
        if (newFile.size > this.allowed_size) {
          this.alert(
            newFile.name +
              ' is too big. The maximum allowed size is: ' +
              Math.round(this.allowed_size / 100000) / 10 +
              ' MB.'
          );
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    async save(form) {
      this.loadingSave = true;
      try {
        let consumption = await ConsumptionController.store(form);
        this.$notify({
          type: 'success',
          title: 'Successfully saved!',
        });

        this.$emit('saved', parseInt(consumption.consumption_category_id));
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
      this.loadingSave = false;
    },
    alert(message) {
      alert(message);
    },
    async saveToBucket(file) {
      this.loadingSave = true;
      try {
        await ConsumptionFileController.storeInBucket({
          file: file.file,
          consumption_category: this.consumption_category.name,
        });
        this.$notify({
          type: 'success',
          title: 'Successfully Uploaded!',
        });
        this.loadingSave = false;
        this.loadingUpload = false;
        this.$emit('reload-invoice-count');
      } catch (error) {
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
        this.loadingUpload = false;
      }
    },
    alert(message) {
      alert(message);
    },
    async uploadFile(file) {
      this.loadingUpload = true;
      let fileIndex = await this.files.findIndex((attachedFile) => {
        return attachedFile.name === file.name;
      });
      try {
        let file_path = await ConsumptionFileController.store({ file: file.file });
        this.files[fileIndex].upload = true;
        this.textWhileUpload = 'Analyse File';
        let extractedText = await this.extractText(file_path, this.files[fileIndex]);
        this.files[fileIndex].analysed = true;

        if (extractedText) {
          let form = this.calculateDays(extractedText);
          form.bill_path = file_path;

          let status = this.getStatus(extractedText);
          this.fillFileForm(fileIndex, form, status);
        } else {
          this.removeFile(this.files[fileIndex]);
        }

        if (this.allFilesUploadedAndAnalysed()) this.loadingUpload = false;
      } catch (error) {
        this.loadingUpload = false;
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },

    async extractText(path, file) {
      try {
        let extractedInfo = await ExtractTextController.store({
          path: path,
          consumption_category_id: parseInt(this.consumption_category_id),
        });
        this.extractedInfo = extractedInfo;
        this.form = extractedInfo;
        return extractedInfo;
      } catch (error) {
        this.$notify({
          type: 'danger',
          title: 'File ' + file.name + ' could not be analysed.',
        });
        return null;
      }
    },
    remove(files) {
      let vm = this;
      files.forEach((file) => {
        vm.$refs.upload.remove(file);
      });
      this.textWhileUpload = 'Upload Files';
      this.fileAttached = false;
    },
    hasNull(target) {
      if (!target) return true;
      if (this.formHasRequiredKeys(target)) {
        for (let member in target) {
          if (this.requiredConsumptionKeys.includes(member)) {
            if (!target[member]) {
              return true;
            }
          }
        }
      } else {
        return true;
      }

      return false;
    },
    calculateDays(extractedInfo) {
      let Difference_In_Days = null;
      if (!extractedInfo.days) {
        if (extractedInfo.start_date && extractedInfo.end_date) {
          let from = new Date(extractedInfo.start_date);
          let to = new Date(extractedInfo.end_date);
          let Difference_In_Time = to.getTime() - from.getTime();
          Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
          extractedInfo.days = Difference_In_Days;
        }
      }
      return extractedInfo;
    },
    removeFile(file) {
      if (this.files.length === 1) this.remove(this.files);
      else this.$refs.upload.remove(file);
    },
    fillFileForm(fileIndex, form, status = 'done') {
      let total_usage = 0;
      let costs = 0;
      form.meters.forEach(function (meter) {
        total_usage += parseInt(meter.total_usage);
        costs += parseInt(meter.amount_paid);
      });
      this.files[fileIndex].status = status;
      this.files[fileIndex].supplier = form.energy_supplier.name;
      this.files[fileIndex].meters = form.number_of_meters;
      this.files[fileIndex].pages = form.pages;
      this.files[fileIndex].usage = total_usage + ' ' + this.consumption_category.unit.text;
      this.files[fileIndex].costs = '$' + costs;
      this.files[fileIndex].form = form;
    },
    openConsumptionForm() {
      this.consumptionModal = true;
    },
    updateForm(event) {
      if (event.file) {
        let fileIndex = this.files.findIndex((file) => {
          return event.file.id === file.id;
        });
        this.fillFileForm(fileIndex, event.form, this.getStatus(event.form));
      } else {
        this.save(event.form);
      }
    },
    allFilesUploadedAndAnalysed() {
      let result = true;
      this.files.forEach((file) => {
        if (!file.upload || !file.analysed) result = false;
      });
      return result;
    },
    getStatus(data) {
      let status = 'done';
      if (this.hasMissingData(data)) {
        status = 'warning';
        this.$notify({
          type: 'warning',
          title: 'Some data could not be parsed! Please fill them manually.',
        });
      } else {
        status = 'done';
        this.$notify({
          type: 'info',
          title: 'Please check the data and press on save',
        });
      }
      return status;
    },
    formHasRequiredKeys(form) {
      let result = true;
      let form_keys = Object.keys(form);
      this.requiredConsumptionKeys.forEach((key) => {
        if (!form_keys.includes(key)) {
          result = false;
        }
      });
      return result;
    },
    allDataPassedCheck() {
      let result = true;

      this.files.forEach((file) => {
        if (file.status !== 'done') result = false;
      });

      return result;
    },
    async saveMultiData(straighToBucket) {
      this.$refs.upload.active = true;
      if (straighToBucket) {
        await Promise.all(
          this.files.map(async (file) => {
            await this.saveToBucket(file);
          })
        );
      } else {
        await Promise.all(
          this.files.map(async (file) => {
            await this.save(file.form);
          })
        );
      }

      this.remove(this.files);
    },
    openFileForm(fileIndex) {
      this.selectedFile = this.files[fileIndex];
      this.selectedForm = this.selectedFile.form;
      this.openConsumptionForm();
    },
    hasMissingData(data) {
      let result = false;
      if (!data.energy_supplier_id) result = true;
      let vm = this;
      data.meters.forEach(function (meter) {
        let dataMissing = vm.hasNull(meter);
        if (!result) result = dataMissing;
      });
      return result;
    },
    isElectricityConsumption(consumption_category_id) {
      return this.consumption_category_id === 1;
    },
    isWaterConsumption(consumption_category_id) {
      return this.consumption_category_id === 5;
    },
  },
};
</script>

<style scoped>
.upload_text {
  display: flex;
  font-size: 2rem;
}
.upload_icon {
  font-size: 6rem;
}
.example-avatar {
  width: 100%;
  height: auto;
  background: #f7fafc;
  border: 0.5px solid #a3a8b1;
  border-radius: 10px;
  padding: 10px;
  position: relative;
}
.example-avatar .text-center .btn {
  margin: 0 0.5rem;
}
.example-avatar .avatar-edit-image {
  max-width: 100%;
}
.example-avatar .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: 0.6;
  text-align: center;
  background: #000;
}
.example-avatar .drop-active h3 {
  margin: -0.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
</style>
